// extracted by mini-css-extract-plugin
module.exports = {"infoMessage":"_15686ae","header":"_f3177c3","icon":"_4f01f56","infoIcon":"_b1dfe57"};